// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#202533","menuText":"#bfcbd9","menuActiveText":"#409eff","chartColor":"#2179ff","lightcycan":"#e0ffff"};